import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { UnstyledUl } from '../../../../../ui';
import Responsive from '../../../../../ui/utils/Responsive';
import type {
	IMenuItemEntry,
	ISiteSectionEntry,
} from '../../../api/contentful/types';
import { AsideNavigationList } from '../aside/AsideNavigationList';
import { BREAKPOINT_SCROLLING_MENU } from '../constants';
import { useNavigationContext } from '../context/NavigationContext';
import { SectionsNavigationList } from './sections/SectionsNavigationList';

interface IMainNavigationItemsProps {
	items: IMenuItemEntry[];
	topSections: ISiteSectionEntry[];
	currentSiteSection: ISiteSectionEntry;
}

export const MainNavigationList = ({
	items,
	topSections,
	currentSiteSection,
}: IMainNavigationItemsProps) => {
	const { setSections, setTopSections, setCurrentTopSection } =
		useNavigationContext();

	useEffect(() => {
		if (items) {
			setSections(items);
		}
	}, [items]);

	useEffect(() => {
		if (topSections) {
			setTopSections(topSections);
		}
	}, [topSections]);

	useEffect(() => {
		if (currentSiteSection) {
			setCurrentTopSection(currentSiteSection);
		}
	}, [currentSiteSection]);

	return (
		<>
			<StyledMainNavigationItemsContainer>
				<SectionsNavigationList isMobileView={false} />
				<AsideNavigationList />
			</StyledMainNavigationItemsContainer>
		</>
	);
};

export const StyledMainNavigationItemsContainer = styled.div`
	display: flex;
	flex-grow: 1;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	@media (${BREAKPOINT_SCROLLING_MENU}) {
		padding: 0;
	}
`;

export const StyledMainNavigationList = styled(UnstyledUl)`
	display: flex;
	align-items: center;
	gap: 4px;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		gap: 0;
		flex-direction: column;
		align-items: stretch;
		justify-content: center;
	}
`;
